/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreatePrivacyRequestRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CreatePrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const createPrivacyRequest = (request:CreatePrivacyRequestRequest, options?: CashRequestOptions) => post<CreatePrivacyRequestRequest, CreatePrivacyRequestResponse>("/2.0/cash/create-privacy-request", request, {...options, rejectOnError: true })